export default __webpack_public_path__ + "static/icon-20-2-fa9082d8fc3b5a2e74f5d4849cc4bfc5.png";